import { CustomerInformation } from 'app/page/orders/model/customer-information';
import { BillingDetails } from 'app/page/orders/model/billing-details';

class CustomerMapper {
    public static mapCustomerInformation(
        partnerId: string,
        customerInformation: OrderTrackerBackend.CustomerInformation,
    ): CustomerInformation {
        return {
            partnerId,
            billingAccountId: customerInformation.billingAccountId,
            fullName: [customerInformation.firstName, customerInformation.lastName].filter(Boolean).join(' '),
            birthDate: customerInformation.dateOfBirth,
            email: customerInformation.email,
            phoneNumber: customerInformation.phoneNumber,
            phoneCountryCode: customerInformation.phoneCountryCode,
            billingDetails: CustomerMapper.mapBillingDetails(customerInformation.billingDetails!),
        };
    }

    private static mapBillingDetails(billingDetails: OrderTrackerBackend.BillingDetails): BillingDetails {
        return {
            invoiceDeliveryMethod: billingDetails.invoiceDeliveryMethod,
            billingRecipientType: billingDetails.billingRecipientType,
            firstName: billingDetails.firstName,
            lastName: billingDetails.lastName,
            billingRecipientEmail: billingDetails.billingRecipientEmail,
            businessName: billingDetails.businessName,
            businessCvr: billingDetails.businessCvr,
            businessGln: billingDetails.businessGln,
        };
    }
}

export { CustomerMapper };
